import React from 'react'
import Svg from './Svg'
export const SvgCheckmarkCircle = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm6.8 9.6L11.4 17c-.3.3-.8.5-1.2.5-.4 0-.8-.1-1.1-.4l-3.9-3.3c-.7-.6-.8-1.7-.2-2.5.6-.7 1.7-.8 2.5-.2l2.6 2.3 6.2-6.2c.7-.7 1.8-.7 2.5 0 .7.6.7 1.7 0 2.4z" />
  </Svg>
))
SvgCheckmarkCircle.isIcon = true
export default SvgCheckmarkCircle
